import ApolloClient from 'apollo-boost';
import fetch from 'isomorphic-fetch';

export const client = new ApolloClient({
  uri: 'https://api-eu-central-1.graphcms.com/v2/ckacccg0200fw01z4f0nc6yzo/master',
  fetch
 
});
